import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';

import {HeaderComponent} from './header.component';
import {MenuModule} from '../menu/menu.module';
import {NotificationsDropdownModule} from '../notifications-dropdown/notifications-dropdown.module';
import {ButtonModule} from '../button/button.module';
import {DialogModule} from '../dialog/dialog.module';
import {SettingsModule} from '../../../settings/settings.module';
import { BackCountBadgeComponent } from './back-count-badge/back-count-badge.component';

@NgModule({
  declarations: [HeaderComponent, BackCountBadgeComponent],
  imports: [
    CommonModule,
    MenuModule,
    NotificationsDropdownModule,
    ButtonModule,
    DialogModule,
    SettingsModule,
  ],
  exports: [HeaderComponent]
})

export class HeaderModule {
}
